import React from 'react';
import withRoot from './modules/withRoot';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import PricingPage from './modules/views/PricingPage';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <PricingPage />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
